import React from 'react'
import cn from 'classnames'
import styles from './Select.module.scss'
import arrowStyle from 'components/shared/style/arrow.module.scss'

const DropdownIndicator = ({ selectProps: { menuIsOpen, isSearchable } }) => (
	<div className={cn('Select__dropdown-indicator', { [styles.searchableIcon]: isSearchable }, menuIsOpen ? arrowStyle['arrow-up'] : arrowStyle['arrow-down'])}/>
)

export default DropdownIndicator
